import React, { Component } from 'react';

enum Ratings
{
	notrated = "Not Rated",
	underreview = "Under Review",
	negative = "Negative",
	neutral = "Neutral",
	bronze = "Bronze",
	silver = "Silver",
	gold = "Gold"
}

export interface MorningstarAnalystRatingProps
{
	rating: keyof typeof Ratings
	noTooltip?: boolean
}

export default class MorningstarAnalystRating extends Component<MorningstarAnalystRatingProps>
{
	render()
	{
		return (
			<div 
				className={`ajb-analyst-rating--${Ratings[this.props.rating].toLowerCase().replace(' ','-')}`} 
				role="img" 
				aria-label={!this.props.noTooltip ? `Morning Star Analyst Rating ${Ratings[this.props.rating]}` : null}
				data-testid="morningStarAnalystRating"
			/>
		);
	}
}